import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';

class LoyaltyPointsTableHeader extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    toggleTable: PropTypes.func.isRequired,
    tableType: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired
  }

  constructor (props) {
    super(props);

    this.toggleTable = this.toggleTable.bind(this);
  }

  toggleTable () {
    this.props.toggleTable(this.props.tableType);
  }

  render () {
    const icon = this.props.open
      ? require('images/icons/chevron-up.svg')
      : require('images/icons/chevron-down.svg');

    return (
      <div
        onClick={this.toggleTable}
        className='loyalty-points-table-header'
      >
        <Translate className='loyalty-points-table-header-title' content={this.props.title} />
        <div className='loyalty-points-table-header-line'></div>
        <img src={icon} />
      </div>);
  }
}

export default LoyaltyPointsTableHeader;



/** WEBPACK FOOTER **
 ** ./src/views/loyalty-program/points-tables/table-header.js
 **/